export const GET_CLOSE = "GET_CLOSE";
export const SET_CLOSE = "SET_CLOSE";
